import React from 'react';
import clsx from 'clsx';
import styles from './StatsGrid.module.css';

export interface StatsGridProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

// StatsGrid component with sub-components interface
interface StatsGridComponent extends React.FC<StatsGridProps> {
  Item: React.FC<React.HTMLAttributes<HTMLDivElement>>;
  Number: React.FC<React.HTMLAttributes<HTMLSpanElement>>;
  Label: React.FC<React.HTMLAttributes<HTMLSpanElement>>;
}

const StatsGrid: React.FC<StatsGridProps> = ({ className, children, ...props }) => {
  return (
    <div className={clsx(styles.statsGrid, className)} {...props}>
      {children}
    </div>
  );
};

// StatsGrid Item Sub-component
const StatsGridItem: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...props }) => {
  return (
    <div className={clsx(styles.statItem, className)} {...props}>
      {children}
    </div>
  );
};

// StatsGrid Number Sub-component
const StatsGridNumber: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...props }) => {
  return (
    <span className={clsx(styles.statNumber, className)} {...props}>
      {children}
    </span>
  );
};

// StatsGrid Label Sub-component
const StatsGridLabel: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...props }) => {
  return (
    <span className={clsx(styles.statLabel, className)} {...props}>
      {children}
    </span>
  );
};

// Attach sub-components to StatsGrid
(StatsGrid as StatsGridComponent).Item = StatsGridItem;
(StatsGrid as StatsGridComponent).Number = StatsGridNumber;
(StatsGrid as StatsGridComponent).Label = StatsGridLabel;

export default StatsGrid as StatsGridComponent;
